import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { isClientOutdated, subscribeClientOutdated } from "@sinch/core/tools/apolloMiddleware/outdatedClient";
import React, { FC, useSyncExternalStore } from "react";
import { useTranslation } from "react-i18next";
import { MdsSyncProblem } from "@sinch/icons";
import { MdsIcon } from "@sinch/components";

/**
 * Prompts the user to reload the page once the server refuses a query of this (outdated) bundle.
 *
 * The application was updated while the page was open, so its persisted queries no longer exist on the server and
 * no request can succeed until the page is reloaded. Requests are parked meanwhile, see `outdatedClientGuardLink`.
 */
export const OutdatedClientDialog: FC = () => {
  const outdated = useSyncExternalStore(subscribeClientOutdated, isClientOutdated);
  const { t } = useTranslation();

  if (!outdated) {
    return null;
  }

  return (
    <Dialog disableEscapeKeyDown maxWidth="xs" open>
      <DialogTitle align="center">
        <MdsIcon icon={MdsSyncProblem} sx={{ fontSize: 120 }} />
      </DialogTitle>
      <DialogTitle align="center" sx={{ pt: 0 }}>
        {t("Error.applicationWasUpdated")}
      </DialogTitle>
      <DialogContent sx={{ textAlign: 'center', pt: 0 }}>
        <DialogContentText>{t("Error.applicationWasUpdatedDescription")}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => globalThis.location.reload()} variant="contained">
          {t("Action.reloadPage")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
